import { 
    apiRequest,
    strukturOrganisasiList,
    strukturOrganisasiActive,
    strukturOrganisasiInactive,
    strukturOrganisasiDetail,
    strukturOrganisasiDetailDraft,
    strukturOrganisasiHirarki, 
    strukturOrganisasiCreate,
    strukturOrganisasiUpdate,
    strukturOrganisasiUpdateDraft,
    strukturOrganisasiEselon,
    strukturOrganisasiEselonDraft,
    strukturOrganisasiCountDraft,
    strukturOrganisasiBknServiceOrganisasi
} from "../../../../../services/adapters/base"

class IndexRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", strukturOrganisasiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchSelect = async (query, cancelToken) => {
        return await apiRequest("get", strukturOrganisasiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", strukturOrganisasiInactive, {
            body: query
        }, true)
    }

    fetchEselon = async (query) => {
        return await apiRequest("get", strukturOrganisasiEselon, {
            params: query
        }, true)
    }
    fetchEselonDraft = async (query) => {
        return await apiRequest("get", strukturOrganisasiEselonDraft, {
            params: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", strukturOrganisasiActive, {
            body: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest('get', strukturOrganisasiDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchDetailDraft = async (query, cancelToken) => {
        return await apiRequest('get', strukturOrganisasiDetailDraft, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchHirarki = async (query, cancelToken) => {
        return await apiRequest('get', strukturOrganisasiHirarki, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest('post', strukturOrganisasiCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest('post', strukturOrganisasiUpdate, {
            body: query
        }, true)
    }

    fetchUpdateDraft = async (query) => {
        return await apiRequest('post', strukturOrganisasiUpdateDraft, {
            body: query
        }, true)
    }

    fetchCountDraft = async (query) => {
        return await apiRequest('get', strukturOrganisasiCountDraft, {
            params: query
        }, true)
    }
    bknServiceOrganisasi = async (query) => {
        return await apiRequest("get", strukturOrganisasiBknServiceOrganisasi, {
            params: query
        }, true)
    }
}

export default IndexRepository
